import React, { useState, useEffect } from "react";
import "./ShopSection.css";
import { FaShoppingCart, FaArrowUp } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const products = [
  {
    id: 1,
    name: "Musambya Bed",
    image: "./images/beds/bed1.jpg",
    price: "$150"
  },
  {
    id: 2,
    name: "Center Table",
    image: "./images/tables/centertable.jpg",
    price: "$220"
  },
  {
    id: 3,
    name: "Dinning Table",
    image: "./images/tables/DinningTable.jpg",
    price: "$180"
  },
  {
    id: 4,
    name: "Indoor & Outdoor Chairs",
    image: "./images/chairs/indoorchair1.jpg",
    price: "$180"
  },
  {
    id: 5,
    name: "Sofa Set",
    image: "./images/chairs/sofaset.jpg",
    price: "$150"
  },
  {
    id: 6,
    name: "Kitchen Cabinets",
    image: "./images/cabinet1.jpg",
    price: "$220"
  },
  {
    id: 7,
    name: "Out Door Chair",
    image: "./images/chairs/outdoor.jpg",
    price: "$180"
  },
  {
    id: 8,
    name: "Counter",
    image: "./images/counters/counter.jpg",
    price: "$180"
  }
];

const ShopSection = () => {
  const [showTopBtn, setShowTopBtn] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const nav =useNavigate()

const handleImageHover = (imageSrc) => {
  setPreviewImage(imageSrc);
};

const closePreview = () => {
  setPreviewImage(null);
};

  useEffect(() => {
    const handleScroll = () => {
      setShowTopBtn(window.scrollY > 300);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <section className="shop-section">
      {/* Hero Section */}
      <div className="shop-hero">
        <div className="hero-content">
          <h1>Welcome to Kajja Galleries Shop</h1>
          <p>Explore unique, curated pieces for your home and office</p>
          <button className="shop-now-btn">Buy Here</button>
        </div>
      </div>

      <div className="shop-header center-content">
        <h2 className="shop-title">Explore Kajja Galleries Shop</h2>
        <p className="shop-subtitle">Refined. Afrocentric. Timeless.</p>
      </div>

      <div className="shop-grid center-content">
        {products.map((product) => (
          <div className="shop-card" key={product.id}>
            <div
                className="image-wrapper"
                onMouseEnter={() => handleImageHover(product.image)}
                onMouseLeave={closePreview}
                >
                <img
                    src={product.image}
                    alt={product.name}
                    className="shop-image"
                    loading="lazy"
                />
                 <div className="price-watermark">On Sale</div>
            </div>
            <div className="shop-info">
              <h3>{product.name}</h3>
              <button onClick={()=>nav('/contact')} className="buy1-button">
                <FaShoppingCart className="icon2" />Order Now
              </button>
            </div>
          </div>
        ))}
      </div>

      {showTopBtn && (
        <button className="scroll-top" onClick={scrollToTop}>
          <FaArrowUp />
        </button>
      )}

        {previewImage && (
        <div className="image-preview-overlay" onMouseLeave={closePreview}>
            <img src={previewImage} alt="Preview" className="preview-image" />
        </div>
        )}
    </section>
  );
};

export default ShopSection;
